import * as React from "react";
const SvgIconSelectedSome = (props) => /* @__PURE__ */ React.createElement("svg", { width: 9, height: 3, viewBox: "0 0 9 3", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 0.333008, y: 0.666504, width: 8.33333, height: 1.66667, rx: 0.833333, fill: "#002C41" }));
export default SvgIconSelectedSome;
